import React from "react"

import { Card } from "react-bootstrap"

function ContactDetails() {
    return (
        <>
            <Card className="p-0 mt-5 mt-xl-0">
                <Card.Body>
                    <Card.Title>
                        <h2 className="text-center">How to reach us</h2>
                    </Card.Title>
                </Card.Body>
            </Card>
            <Card className="p-0 mt-4">
                <Card.Body>
                    <h3 className="h4 mt-3">Find us in branch</h3>
                    <ul className="card-address">
                        <li className="card-address list-pad">
                            <span>
                                Suite 18, Salisbury Gardens, Dudley Rd, Ventnor,
                                IOW PO38 1EJ
                            </span>
                        </li>
                    </ul>

                    <h3 className="h4 mt-3">Contact us remotely</h3>
                    <ul className="card-email">
                        <li className="card-email list-pad">
                            <span>propertyservices@webbjenkins.co.uk</span>
                        </li>
                    </ul>

                    <ul className="card-number">
                        <li className="card-number list-pad">
                            <a href="tel:01983 856111" role="button">
                                <span>01983 856111</span>
                            </a>
                        </li>
                    </ul>
                </Card.Body>
            </Card>
        </>
    )
}

export default ContactDetails
